import { render } from "./UploadButton.vue?vue&type=template&id=4c0ad142"
import script from "./UploadButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/exhishare/UploadButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c0ad142"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c0ad142', __exports__)) {
    api.reload('4c0ad142', __exports__)
  }
  
  module.hot.accept("./UploadButton.vue?vue&type=template&id=4c0ad142", () => {
    api.rerender('4c0ad142', render)
  })

}


export default __exports__